<template>
  <div class="col_6">
    <div class="card vlan_home_email_trackers">
      <div class="card_heading">
        <div class="fw_600">{{ title }}</div>
      </div>
      <div class="card_body ">
        <div class="">
          <div class="table_responsive">
            <table class="table">
              <tbody>
              <template v-if="activities?.length > 0">
                <tr v-for="activity in activities" :key="'activity_'+activity.id">
                  <td>
                    <router-link :to="`/ticket/${activity?.loggable?.ticket_number}`">
                      <div class="contact_name">
                        <div class="avatar info_bg">
                          <span>{{ getFirstCharacter(activity?.actor?.name) }}</span>
                        </div>
                        <div class="text">
                          <p class="mb_5"> <span class="fw_600">{{ activity?.actor?.name }}</span>
                            <template v-if="activity.action === 'created'"> created </template>
                            <template v-else> has sent a response to the</template> ticket {{ activity?.loggable?.subject }} (#{{ activity?.loggable?.ticket_number }})
                          </p>
                          <p class="mb_0">{{ activity.created_at }}</p>
                        </div>
                      </div>
                    </router-link>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td>No activities found!</td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityLogComponent",
  props: ['title', 'activities'],
  data() {
    return {}
  },
  methods: {
    getFirstCharacter(name) {
      return name.charAt(0);
    },
  }
}
</script>
<style scoped>

</style>